import { useCallback } from 'react'
import { batch } from 'react-redux'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { LESSON_AUDIO_PLAYING_STATUS } from 'src/constants/lesson.constant'
import { storyLesson_selectState, storyLesson_reducerActions } from 'src/redux/story-lesson'

export const useStoryLesson = () => {
  const dispatch = useDispatch()
  const state = useSelector(storyLesson_selectState)

  const storyLesson_onPlayAudio = useCallback(
    url => {
      if (!url || url === state.storyLesson_currentAudioUrl) {
        batch(() => {
          dispatch(storyLesson_reducerActions.storyLesson_setPlayingStatus(LESSON_AUDIO_PLAYING_STATUS.STOPPED))
          dispatch(storyLesson_reducerActions.storyLesson_setCurrentAudioUrl(null))
        })
      } else if (url) {
        setTimeout(() => {
          batch(() => {
            dispatch(storyLesson_reducerActions.storyLesson_setCurrentAudioUrl(url))
            dispatch(storyLesson_reducerActions.storyLesson_setPlayingStatus(LESSON_AUDIO_PLAYING_STATUS.PLAYING))
          })
        }, 300)
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state.storyLesson_currentAudioUrl]
  )

  return {
    ...state,
    ...storyLesson_reducerActions,
    storyLesson_onPlayAudio,
  }
}
